'use strict'

import modalArchivoController from './archivoModal.controller';
import modalArchivoTemplate from './archivoModal.html';
class listaCierreController{
	constructor(Proyecto,DataService,Storage,Modal){
		'ngInject';
		this.Proyecto = Proyecto;
		this.DataService = DataService;
		this.Storage = Storage;
		this.Modal = Modal;
	}
	$onInit(){
		this.usuario = this.Storage.getUser();
    setTimeout(()=>{
			if(!this.proyecto.cierre.lista_cierre) {
				this.obtenerFormCierre();
			}
		},2000)
		
	this.prueba = 'hola mundo'
		// console.log(this.formulario.cierre)
	}
	obtenerFormEvaluacion() {


  }
  radioChange(cols, index,indexfila) {
    if (!this.modoVista) {
      for (let i in cols) {
        
        if (cols[i].contenido && cols[i].contenido.type === 'radio') {
          if(indexfila == 5){
            // console.log('tiene acta provisional?', (this.proyecto.seguimiento.doc_acta_provisional != null))
          }
          cols[i].contenido.value = (i == index);
          // console.log("(i == index)   Muestra   ",(i == index))
        }
      }
      // if (cols[index].contenido.name === 'NO_CUMPLE') {
      //   this.marcarInformeRechazado();
      // }
    }
  }

  radioColor(contenido) {
    if (contenido.value && contenido.name == 'CUMPLE') return 'btn-success';
    if (contenido.value && contenido.name == 'NO_CUMPLE') return 'btn-danger';
    if (contenido.value && contenido.name == 'NO_APLICA') return 'btn-primary';
    if (contenido.value && contenido.name == 'APROBADO') return 'btn-success';
    if (contenido.value && contenido.name == 'AJUSTE') return 'btn-warning';
    if (contenido.value && contenido.name == 'RECHAZO') return 'btn-danger';
    return 'btn-secondary';
  }

  guardarChecklist(){
    // this.datos = {
		// 	fid_proyecto: this.proyecto.id_proyecto,
		// 	//plazo_cierre: this.proyecto.cierre.plazo_cierre,
		// 	lista_cierre: this.proyecto.
		// 	_usuario_creacion: this.usuario.id_usuario
		// };

		this.DataService.post(`proyectos/cie`, this.proyecto)
			.then(response=>{
				if(response){
					this.Message.success("Proyecto actualizado correctamente.");
					//this.proyecto.seguimiento = response.datos
					// console.log("datos recibidos despues de guardar: ",this.proyecto)
					
					this.Loading.hide();
					//this.$state.reload();			
				}
			})
  }


  obtenerFormCierre() {
    
    this.proyecto.cierre.lista_cierre = [];
    this.DataService.get(`contenidos/listacierre/1`).then(response => {
      if (response) {
        if (response.datos && response.datos.estructura) {

          this.proyecto.cierre.lista_cierre = response.datos.estructura;
        }
      }
    });
	}

	regenerarFormulario() {
    this.obtenerFormCierre();
  }

  mostrarModal(titulo, icon, data, template, controller, labelOk, size) {
    return  this.Modal.show({
      template: template,
      controller: controller,
      data: data || {},
      title: titulo,
      icon: icon,
      size: size?size:'md',
      labelOk: labelOk
    });
  }

  cargarAdjunto(adj) {
    const confArchivo = {
      formatos: 'pdf',
      tipos: '.pdf'
    };
    // console.log(adj)
    let codigo_documento = [];
    if((adj[1].codigo == 'doc_solicitud_cierre')) codigo_documento = ['doc_solicitud_cierre', adj[1].titulo];
    if((adj[0].codigo == 'doc_acta_cierre')) codigo_documento = ['doc_acta_cierre', adj[0].titulo];
    if((adj[1].codigo == 'doc_informe_auditoria_final')) codigo_documento = ['doc_informe_auditoria_final', adj[1].titulo];
    
    // console.log(codigo_documento)

    this.mostrarModal(` - "${codigo_documento[1]}"`, 'fa-upload', confArchivo, modalArchivoTemplate, modalArchivoController, 'Cargar documento')
    .result.then( documentoAdjunto => {
      if (angular.isUndefined(documentoAdjunto)) {
        return;
      }
      this.DataService.put(`cierre/${this.proyecto.id_proyecto}`, {datos_adjunto: documentoAdjunto, cod_doc: codigo_documento}).then(result => {
        if (result && result.finalizado) {
          //this.Message.success(`Se registró el documento de especificaciones técnicas del item "${item.nombre}" correctamente.`);
          // item.especificaciones = docEspecificaciones;
        }
      });
    });
  }

  verAdjunto(index, adj){
    // this.Modal.alert('Aqui vendra el adjunto : '+ adj[0].titulo)
    let codigo_documento = [];
    if((adj[1].codigo == 'doc_solicitud_cierre')) codigo_documento = ['doc_solicitud_cierre', adj[1].titulo];
    if((adj[0].codigo == 'doc_acta_cierre')) codigo_documento = ['doc_acta_cierre', adj[0].titulo];
    if((adj[1].codigo == 'doc_informe_auditoria_final')) codigo_documento = ['doc_informe_auditoria_final', adj[1].titulo];
    
    if(codigo_documento[0] == 'doc_solicitud_cierre'){
      this.Modal.showDocumentBase64(`proyectos/${this.proyecto.id_proyecto}/doc/SCC`,` -"${codigo_documento[1]}"`);
    }

    if(codigo_documento[0] == 'doc_acta_cierre'){
      this.Modal.showDocumentBase64(`proyectos/${this.proyecto.id_proyecto}/doc/DAC`,` -"${codigo_documento[1]}"`);
    }

    if(codigo_documento[0] == 'doc_informe_auditoria_final'){
      this.Modal.showDocumentBase64(`proyectos/${this.proyecto.id_proyecto}/doc/IAF`,` -"${codigo_documento[1]}"`);
    }
  
  }

  verAdjuntoSeguimiento(index){
    if (index == 5){
      this.Modal.showDocumentBase64(`proyectos/${this.proyecto.id_proyecto}/doc/ACP`);
    }

    if (index == 6){
      this.Modal.showDocumentBase64(`proyectos/${this.proyecto.id_proyecto}/doc/ACD`);
    }

    if (index == 7){
      this.Modal.showDocumentBase64(`proyectos/${this.proyecto.id_proyecto}/doc/ODP`);
    }
  }

}
export default listaCierreController;


// WEBPACK FOOTER //
// ./src/app/components/reg-proyectos/c-proyectos/lista-cierre/lista-cierre.controller.js